
export const isFemale = (val?: string) => {
    if (!val) return false;
    const value = val.toLowerCase();
    return (
        value === "k" ||
        value === "f" ||
        value === "female" ||
        value === "kadın" ||
        value === "kadin"
    );
};
